import { render, staticRenderFns } from "./PropertyCrmForm.vue?vue&type=template&id=88f0d546&scoped=true&"
import script from "./PropertyCrmForm.vue?vue&type=script&lang=js&"
export * from "./PropertyCrmForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f0d546",
  null
  
)

export default component.exports